<script>
import { SITE_SLUG } from '@constants/siteDetails'
import { mapActions, mapGetters } from 'vuex'
import RetriesLoadOnDisplay from '@mixins/retries-load-on-display'

export default {
  name: 'WithSite',
  mixins: [RetriesLoadOnDisplay],
  data() {
    return {
      isSiteLoading: false,
      siteSlug: SITE_SLUG,
    }
  },
  computed: {
    ...mapGetters('site', ['getSite', 'isApiOffline']),
    theSite() {
      return this.getSite || {}
    }, // theSite
  },
  watch: {
    siteSlug: {
      async handler(val) {
        this.isSiteLoading = true
        await this.loadSite()
        this.isSiteLoading = false
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('site', ['fetchSite']),
    async loadSite() {
      await this.fetchSite({ siteSlug: this.siteSlug })
      if (this.isApiOffline) this.retryLoadOnDisplay(this.loadSite)
    },
  },
  render() {
    return this.$scopedSlots.default({
      theSite: this.getSite || false,
      isSiteLoading: this.isSiteLoading,
    })
  },
}
</script>
